import { useState } from "react"
import { useAuth } from "@/hooks/use-auth"
import { useCurrentOrg } from "@/hooks/use-current-org"
import { Button } from "@/components/ui/button"
import { Building2, X } from "lucide-react"

function dismissKey(tenantId: string): string {
  return `tenantBannerDismissed:${tenantId}`
}

export function TenantContextBanner() {
  const { availableTenants } = useAuth()
  const currentSlug = useCurrentOrg()
  const currentTenant = availableTenants.find((t) => t.slug === currentSlug)
  const tenantId = currentTenant ? currentTenant.id : ""
  const [bumpDismiss, setBumpDismiss] = useState(0)
  const dismissed = tenantId
    ? localStorage.getItem(dismissKey(tenantId)) === "1"
    : false
  void bumpDismiss

  function handleDismiss() {
    if (!tenantId) return
    localStorage.setItem(dismissKey(tenantId), "1")
    setBumpDismiss((n) => n + 1)
  }

  function handleSwitch() {
    const trigger = document.querySelector<HTMLButtonElement>('[data-test="org-switcher"]')
    if (trigger) {
      trigger.focus()
      trigger.click()
    }
  }

  if (availableTenants.length <= 1) return null
  if (!currentTenant) return null
  if (dismissed) return null

  return (
    <div
      className="flex items-center gap-3 border-b border-amber-200 bg-amber-50 px-4 py-2 text-sm text-amber-900 dark:border-amber-800 dark:bg-amber-900/30 dark:text-amber-100"
      data-test="tenant-context-banner"
      role="status"
    >
      <Building2 className="h-4 w-4 shrink-0" aria-hidden />
      <p className="min-w-0 flex-1 truncate">
        Vous êtes sur <strong className="font-semibold">{currentTenant.name}</strong>{" "}
        <span className="font-mono text-xs opacity-80" data-test="tenant-context-banner-slug">
          ({currentTenant.slug})
        </span>
      </p>
      <Button
        size="sm"
        variant="outline"
        className="h-7 border-amber-300 bg-white px-2 text-xs text-amber-900 hover:bg-amber-100 dark:border-amber-700 dark:bg-amber-950 dark:text-amber-100 dark:hover:bg-amber-900"
        onClick={handleSwitch}
        data-test="tenant-context-banner-switch"
      >
        Changer
      </Button>
      <Button
        size="sm"
        variant="ghost"
        className="h-7 w-7 p-0 text-amber-900 hover:bg-amber-100 dark:text-amber-100 dark:hover:bg-amber-900"
        onClick={handleDismiss}
        data-test="tenant-context-banner-dismiss"
        aria-label="Masquer la bannière"
      >
        <X className="h-3.5 w-3.5" />
      </Button>
    </div>
  )
}
